import { FeedList } from '@/components/feed';

import { Layout } from '../components/Layout';

export function HomePage() {
  return (
    <Layout>
      <div className="max-w-2xl mx-auto px-4 py-8">
        <FeedList />
      </div>
    </Layout>
  );
}
